// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectBoxBonusNames__container--2VLtU","BonusGroupsWrapper":"SelectBoxBonusNames__BonusGroupsWrapper--2r8m_"};